<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="accionesPGNCIFDynamic && accionesPGNCIFDynamic.length > 0 && hasSelected"
      >
      <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesPGNCIFDynamic" :key="action.id">
            <base-button-item-list theme="dark"  @click="executeAction(action)">
              <base-icon :name="action.icon" class="mr-2" :ariaHidden="true"/>
              {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" v-if="!isRoleUserOrConsulta" :text="$t('locations.link_location')" icon="link" @click="goLinkLocation" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <BaseElDialog
        title="Desvincular sedes"
        :visible.sync="showModalDeleteAEAT"
        @open="handleOpenModalDialog('container-handleOpenModal-unlink')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDesvincularAEAT }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink">
            <base-button class="w-full" @click="showModalDeleteAEAT = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteAEATHandler(); showModalDeleteAEAT = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <company-link-location-dialog :dialogOpen="linkLocation" @toggleDialog="toggleDialogs" @applyDialog="applyLinkHandler" />
      <company-locations-link-agency-exclusion-dialog 
        :dialogOpen="linkAgencyExcluded" 
        :companyId="id" 
        :pgnId="idPGNSelected" 
        @toggleDialog="toggleDialogsAgencyExcluded" 
        @applyDialog="applyLinkHandlerAgencyExcluded" 
        :agenciesBase="agenciesBaseTemp"
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>

    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/LocationsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
// import { getSedes } from '@/services/app/getSedes'
import { getLocations } from '@/services/companies/getLocations'
import { getCompany } from '@/services/companies/getCompany'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import CompanyLinkLocationDialog from '@/components/CompanyLinkLocationDialog.vue'
import CompanyLocationsLinkAgencyExclusionDialog from '@/components/CompanyLocationsLinkAgencyExclusionDialog.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import { linkLocation } from '@/services/companies/linkLocation'
import { unlinkLocations } from '@/services/companies/unlinkLocations'
import { getCompanyLocationsExcel } from '@/services/companies/getCompanyLocationsExcel'
import { changeRevisarTodo } from '@/services/companies/changeRevisarTodo'
import { updateAgenciesExclusions } from '@/services/companies/updateAgenciesExclusions'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

export default {
  name: 'locations',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    CompanyLinkLocationDialog,
    CompanyLocationsLinkAgencyExclusionDialog,
    BaseElDialog,
  },
  data: function () {
    return {
      idVista: 16,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      accionesPGNCIF: [
        {
          id: 1,
          name: 'Activar Revisar todo',
          icon: 'check'
        },
        {
          id: 2,
          name: 'Desactivar Revisar todo',
          icon: 'cross'
        },
        {
          id: 3,
          name: this.$i18n.t('app.agency_edit'),
          icon: 'exclude-agencies'
        },
        {
          id: 4,
          name: 'Desvincular',
          icon: 'unlink'
        },
      ],
      showModalDeleteAEAT: false,
      processMessageDesvincularAEAT: 'La sede AEAT esta excluida por defecto en Dehú ¿Estás seguro que deseas desconectar la AEAT?',
      excludeAgenciesDialog: false,
      loadingExcel: false,
      showModal: false,
      linkLocation: false,
      linkAgencyExcluded: false,
      spanish: true,
      header: {
        title: i18n.t('app.locations_link'),
        icon: 'companies',
        breadcrumb: null,
        url: 'companies/detail'
      },
      vuexnamespace: 'companylocations',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    accionesPGNCIFDynamic () {
      const acciones = this.accionesPGNCIF
      // if (this.rowsSelected > 1) return acciones.filter(x => x.id !== 3)
      if (this.rowsSelected === 1 && 
        this.selected.length === this.selected.filter(x => !x.RevisarTodo).length && 
        this.hasModuleExclusionOrganismos) { 
        return acciones 
      }
      return acciones.filter(x => x.id !== 3)
    },
    agenciesBaseTemp () {
      if (this.rowsSelected === 0 || this.rowsSelected > 1) return null
      if (this.selected[0].Organismos === undefined || this.selected[0].Organismos === null) return null
      return this.selected[0].Organismos.map(x => x)
    },
    idPGNSelected () {
      if (this.rowsSelected === 0 || this.rowsSelected > 1) return null
      if (this.selected[0].IdPGN === undefined || this.selected[0].IdPGN === null) return null
      return this.selected[0].IdPGN
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleExclusionOrganismos () {
      return this.$store.getters['auth/hasModuleExclusionOrganismos']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    id () {
      return parseInt(this.$route.params.id)
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    // if (this.isRoleUserOrConsulta) this.kendo.columns.shift()
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    const companyId = this.$route.params.id
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: this.$i18n.t('app.companies') })
    if (companyId !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const company = await this.downloadCompanyData(companyId)
        breadcrumbs.push({ path: '', name: company.NombreCIF })
      }
    }
    this.header.breadcrumb = breadcrumbs
    this.data = await this.applyFilters()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    toggleDesvincularAEAT: async function () {
      this.showModalDeleteAEAT = !this.showModalDeleteAEAT
    },
    deleteAEATHandler () {
      this.unlink()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 4) { // desvincular
        if (this.selected.filter(x => x.IdPGN === 203).length > 0) {
          this.toggleDesvincularAEAT()
        } else {
          this.deleteAEATHandler()
        }
      } else if (this.selectedAction.id === 3) {
        this.toggleDialogsAgencyExcluded()
      } else if (this.selectedAction.id === 2) {
        this.handleRevisarTodo(false)
      } else {
        this.handleRevisarTodo(true)
      }
    },
    handleRevisarTodo: async function (valor) {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFEmpresa = this.$route.params.id
        const idPGNs = this.selected.map(x => x.IdPGN)
        const idPgncifs = []
        idPGNs.forEach(x => {
          idPgncifs.push({
            idPGN: x,
            idCIFEmpresa: idCIFEmpresa
          })
        })
        const payload = { 
          idPgncifs: idPgncifs,
          RevisarTodo: valor,
        }
        const response = await changeRevisarTodo(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
          this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyExcludeAgenciesHandler: async function (agencies) {
      this.linkTagToOrganismos = false
      await this.excludeAgenciesHandler(agencies)
      this.applyFilters()
    },
    excludeAgenciesHandler: async function (agencies) {
      // try {
      //   this.$store.commit('setIsLoading', true)
      //   const tagID = this.$route.params.id
      //   const payload = { idTag: tagID, idOrganismos: agencies }
      //   const response = await linkTagToOrganismos(payload)
      //   if (response.blnError === true) {
      //     this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
      //   } else {
      //     this.doFeedback('Vinculado correctamente', 'success')
      //   }
      // } catch (error) {
      //   this.doFeedback()
      // } finally {
      //   this.$store.commit('setIsLoading', false)
      // }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      // console.log('Ir a registro con ID: ', event.dataItem.id)
      // this.$router.push({ name: 'companies/locations/detail', params: { location_id: event.dataItem.id } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkLocation = !this.linkLocation
    },
    toggleDialogsAgencyExcluded: function () {
      this.linkAgencyExcluded = !this.linkAgencyExcluded
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        nombre: data.Nombre ? data.Nombre.value : null,
        codigo: data.Codigo ? data.Codigo.value : null,
        URL: data.URL ? data.URL.value : null,
        idCIFEmpresa: this.$route.params.id,
        revisarTodo: data.revisarTodo ? data.revisarTodo.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdPGN)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getCompanyLocationsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'empresa-sedes.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      try {
        const params = {
          nombre: data.Nombre ? data.Nombre.value : null,
          codigo: data.Codigo ? data.Codigo.value : null,
          URL: data.URL ? data.URL.value : null,
          revisarTodo: data.revisarTodo ? data.revisarTodo.value : null,
          nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        }
        const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      res.respuesta.forEach(x => {
        x.Organismos = x.OrganismosExcluidos.map(y => y)
        if (x.RevisarTodo) x.OrganismosExcluidos = []
        else x.OrganismosExcluidos = x.OrganismosExcluidos.map(y => y.Nombre)
      })
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        idCIFEmpresa: this.$route.params.id,
        ...filters
      }
      const data = await getLocations(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { IdCifEmpresa: companyId }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(company.msgError + ' [Código de error: ' + company.codError + ']')
        } else {
          return company.CIFSEmpresa[0]
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    unlink: async function () {
      const ids = this.selected.map(item => item.IdPGN)
      this.$store.commit('setIsLoading', true)
      const response = await unlinkLocations({ IdCIFEmpresa: this.$route.params.id, IdPGNS: ids })
      this.$store.commit('setIsLoading', false)
      if (response.blnError === false) {
        this.doFeedback('Desvinculado correctamente', 'success')
      } else {
        this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
      }

      this.data = await this.applyFilters()
    },
    sendMessage: async function () {
      //
    },
    goLinkLocation: function () {
      this.linkLocation = !this.linkLocation
    },
    applyLinkHandler: async function (pgns) {
      this.linkLocation = false
      await this.linkHandler(pgns)
      this.applyFilters()
    },
    applyLinkHandlerAgencyExcluded: async function (agencies) {
      await this.linkHandlerAgencyExcluded(agencies)
      this.applyFilters()
    },
    linkHandler: async function (pgnsId) {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIF = this.$route.params.id
        const payload = { idCIF: idCIF, pgnCerts: [] }
        pgnsId.forEach(element => {
          payload.pgnCerts.push({ idPGN: element })
        })
        const response = await linkLocation(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    linkHandlerAgencyExcluded: async function (agencies) {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFEmpresa = this.$route.params.id
        const idPGN = this.selected[0].IdPGN
        const payload = { 
          idPGN, 
          idCifEmpresa: idCIFEmpresa,
          idOrganismos: agencies
        }
        const response = await updateAgenciesExclusions(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.toggleDialogsAgencyExcluded()
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
